import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import UnitOfMeasureServices from "./UnitOfMeasureServices";

const initialState = {
  unitOfMeasures: [],
  unitOfMeasure: null,
  isError: false,
  isSuccess: false,
  isSuccessCreateUpdate: false,
  isLoading: false,
  message: "",
};

export const createUOM = createAsyncThunk(
  "unitOfMeasure/createUOM",
  async (name, thunkAPI) => {
    try {
      return await UnitOfMeasureServices.createUOM(name);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getAllUOMs = createAsyncThunk(
  "unitOfMeasure/getAllUOMs",
  async (_, thunkAPI) => {
    try {
      return await UnitOfMeasureServices.getAllUOMs();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const updateUOM = createAsyncThunk(
  "unitOfMeasure/updateUOM",
  async ({ id, name }, thunkAPI) => {
    try {
      return await UnitOfMeasureServices.updateUOM({ id, name });
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const deleteUOM = createAsyncThunk(
  "unitOfMeasure/deleteUOM",
  async (id, thunkAPI) => {
    try {
      return await UnitOfMeasureServices.deleteUOM(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const unitOfMeasureSlice = createSlice({
  name: "unitOfMeasure",
  initialState,
  reducers: {
    RESET_UNIT_OF_MEASURE(state) {
      state.isError = false;
      state.isSuccess = false;
      state.isSuccessCreateUpdate = false;
      state.isLoading = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createUOM.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(createUOM.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccessCreateUpdate = true;
        state.unitOfMeasure = action.payload.newUOM;
      })

      .addCase(createUOM.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })

      .addCase(updateUOM.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(updateUOM.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccessCreateUpdate = true;
        state.unitOfMeasure = action.payload.updatedUOM;
      })

      .addCase(updateUOM.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })
      .addCase(getAllUOMs.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(getAllUOMs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.unitOfMeasures = action.payload;
      })

      .addCase(getAllUOMs.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      })

      .addCase(deleteUOM.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(deleteUOM.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.unitOfMeasure = action.payload;
      })

      .addCase(deleteUOM.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        toast.error(action.payload);
      });
  },
});

export const { RESET_UNIT_OF_MEASURE } = unitOfMeasureSlice.actions;
export const selectUnitOfMeasures = (state) =>
  state.unitOfMeasure.unitOfMeasures;
export const selectSuccessCreateUpdate = (state) =>
  state.unitOfMeasure.isSuccessCreateUpdate;

export default unitOfMeasureSlice.reducer;
